/**
 * @file
 *
 * Customization script for the 'pam/member' form.
 */

import $ from 'jquery'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

// set the type to function and set function to window object for public use (calling from app.js)
window.setMemberPerintatapaSelections = function (exist) {

  /*
   * Työnantajaperintä oletuksena valituksi, kun lisätään uusia työsuhteita
   */
  // perinta radiobuttons - search all tag names without indexnumber - tag tyosuhde[][perinta] can be up to index 4
  const $perintaRadio = $("input:radio[name^='tyosuhde['][name$='[perinta]']")
      
  // for adding new employment relationship - set the value "K" for perinta radiobutton
  if ((exist === false)) {
    // reverse() reverses the order of elements in an array.
    $($perintaRadio.get().reverse()).each(function (index) {
      const self = $(this)
      const val = self.val()
      // TA-perinta is checked by default when adding new employment relationship. The values of perinta of existing employment relationships will not be changed.
      if (val === 'K') {
        self.prop('disabled', false)
        self.prop('checked', true)
        return false
      }
    })
  }

  // JLP-463: otetaan toistaiseksi pois mahdollisuus liittyä vain liittoon ja siihen liittyvät perintä radiobuttoneiden asetukset
  // The choice of whether to join the union or both the union and the fund
  // const value = $('input[name=liittyy_kassa_liitto]:checked').val()
  // for added employment relationship(s) - remove choices of perinta radiobuttons
  // if ((value === 'liitto') && (exist === true)) {
  //   $perintaRadio.each(function (index) {
  //     // $(this) refers to perintatapa radiobutton element
  //     const self = $(this)
  //     const val = self.val()
  //     if (val === 'E') {
  //       self.prop('checked', false)
  //     } else if (val === 'K') {
  //       self.prop('checked', false)
  //       self.prop('disabled', true)
  //     }
  //   })
  // }   
  // // for adding new employment relationship
  // } else if ((value === 'liitto') && (exist === false)) {
  //   $perintaRadio.each(function (index) {
  //     const self = $(this)
  //     const val = self.val()
  //     if (val === 'K') {
  //       self.prop('disabled', true)
  //     }
  //   })
  // }
  // // for added employment relationship(s) - set the value "K" for perinta radiobutton
  // } else {
  //   $perintaRadio.each(function (index) {
  //     const self = $(this)
  //     const val = self.val()
  //     if (val === 'K') {
  //       self.prop('disabled', false)
  //       self.prop('checked', true)
  //     } else if (val === 'E') {
  //       self.prop('checked', false)
  //     }
  //   })
  // }
  // end JLP-463: otetaan toistaiseksi pois mahdollisuus liittyä vain liittoon ja siihen liittyvät perintä radiobuttoneiden asetukset
}

$(document).ready(() => {

  console.log('member.js: document is ready')

  const $edKassaSection = $('#ed_kassa')
  const $edLiittoSection = $('#ed_liitto')
  const $edKassaValtuutusUusiCbox = $('[name=ed_kassa_valtuutus_uusi]')
  const $edLiittoValtuutusCbox = $('[name=ed_liitto_valtuutus]')
  const $edKassaSelect = $('[name=ed_kassa_uusi]')
  const $siirtyyLiitostaCheckbox = $('[name=siirtyy_liitosta]')
  const $edLiittoSelect = $('[name=ed_liitto]')
  const $siirtyyKassastaRadios = $('input:radio[name=siirtyy_kassasta_uusi]')
  const $liittyyKassaLiittoRadio = $('[name=liittyy_kassa_liitto]')
  const $forename = $('[name=etunimet]')
  const $nickname = $('[name=kutsumanimi]')
  const $perintaRadio = $("input:radio[name^='tyosuhde['][name$='[perinta]']")
  

  /*
   * Työnantajaperintä oletuksena valituksi ensimmisessä työsuhteessa
   */
  $($perintaRadio.get().reverse()).each(function (index) {
    const self = $(this)
    const val = self.val()
    if (val === 'K') {
      self.prop('disabled', false)
      self.prop('checked', true)
      return false
    }
  })






  // TODO POISTETAAN MYÖHEMMIN
  // function debugValtuutukset() {
  //   const fieldsAndVals = $('form').serialize().split('&').filter(
  //     (v) => {
  //       if (
  //         v.indexOf('ed_kassa_valtuutus_uusi') > -1 || 
  //         v.indexOf('ed_liitto_valtuutus') > -1
  //       ) {
  //         return true
  //       }
  //       return false
  //     }
  //   ).sort().join('\n') || 'ei löydy'
  //   console.log('-----------------------\n' + decodeURI(fieldsAndVals) + '\n-----------------------')
  // }
  // $('button[type=submit]').on('mousedown', debugValtuutukset)
  // TODO POISTETAAN MYÖHEMMIN ends



  $forename.on('blur', () => {
    if ($forename.val()) {
      $nickname.val($forename.val().split(' ')[0])
    }
  })

  // Liityn Palvelualojen ammattiliiton ja Palvelualojen työttömyyskassan jäseneksi /
  // Liityn vain Palvelualojen ammattiliiton jäseneksi 
  if ($liittyyKassaLiittoRadio.length > 0) {
    $liittyyKassaLiittoRadio.on('change', () => {

      const kassaLiittoRadio = $("input[type='radio'][name='liittyy_kassa_liitto']:checked")
      const kassaLiittoRadioVal = kassaLiittoRadio.length > 0 ? kassaLiittoRadio.val() : null

      // JLP-463: otetaan toistaiseksi pois mahdollisuus liittyä vain liittoon ja siihen liittyvät perintä radiobuttoneiden asetukset
      // if (kassaLiittoRadioVal === 'liitto' || kassaLiittoRadioVal === 'liittotk') {
      //   const exist = true
      //   window.setMemberPerintatapaSelections(exist)
      // }
      // end JLP-463: otetaan toistaiseksi pois mahdollisuus liittyä vain liittoon ja siihen liittyvät perintä radiobuttoneiden asetukset

      $edKassaValtuutusUusiCbox.prop('checked', false)
      $edKassaValtuutusUusiCbox.trigger('change', [kassaLiittoRadioVal])

      // debugValtuutukset()
    })
  }


  /*
   * Valtuutan PAMin irtisanomaan jäsenyyteni edellisessä liitossa / työttömyyskassassa
   * Jos valittu erovaltuutus (ed_kassa_valtuutus_uusi), lähetetään myös liiton erovaltuutus (ed_liitto_valtuutus)
   */
  if ($edKassaValtuutusUusiCbox.length > 0) {
    $edKassaValtuutusUusiCbox.on('change', () => {
      const checked = $edKassaValtuutusUusiCbox.is(':checked')

      if (checked) {
        $edKassaValtuutusUusiCbox.prop('checked', true)
        $edLiittoValtuutusCbox.prop('checked', true)
        checkSiirtyySuomalainenTK()
        naytaKassa()
        checkSiirtyyToisestaLiitosta()
        naytaLiitto()
      } else {
        $edKassaValtuutusUusiCbox.prop('checked', false)
        $edLiittoValtuutusCbox.prop('checked', false)
        resetoiKassa()
        piilotaKassa()
        resetoiLiitto()
        piilotaLiitto()
      }
    })
  }

  /* 
  * Siirryn suomalaisesta työttömyyskassasta /
  * Siirryn ulkomaisesta työttömyyskassasta / 
  * En siirry toisesta työttömyyskassasta 
  */
  if ($siirtyyKassastaRadios.length > 0) {
    $siirtyyKassastaRadios.on('change', () => {

      // Siirryn suomalaisesta työttömyyskassasta (1)
      const movesFromFund = $siirtyyKassastaRadios.filter('[value=1]').prop('checked')

      if (!movesFromFund) {
        // Edellinen työttömyyskassa
        $edKassaSelect.val("")
        $edKassaSelect.trigger('change') // Activate data-show-if bindings
      } 
    })
  }

  // Siirryn toisesta liitosta (Edellisen liiton jäsenyyden alla)
  if ($siirtyyLiitostaCheckbox.length > 0) {
    $siirtyyLiitostaCheckbox.on('change', () => {

      $edLiittoSelect.trigger('change') // Activate data-show-if bindings

      // JLP-442 Correcting value of hidden checkbox unchecked wrongly by data-show-if/data-clear functionality.
      const edKassaValtuutusUusiChecked = $edKassaValtuutusUusiCbox.is(':checked')
      const kassaLiittoRadio = $("input[type='radio'][name='liittyy_kassa_liitto']:checked")
      const kassaLiittoRadioVal = kassaLiittoRadio.length > 0 ? kassaLiittoRadio.val() : null
      
      if (edKassaValtuutusUusiChecked) {
        if (kassaLiittoRadioVal === 'liittotk') {
          setTimeout(() => {$edLiittoValtuutusCbox.prop('checked', true)}, 0)
        } else if (kassaLiittoRadioVal === 'liitto') {
          setTimeout(() => {$edKassaValtuutusUusiCbox.prop('checked', false)}, 0)
        } 
      }

      // setTimeout(debugValtuutukset, 100) // TODO: POISTA LOKITUKSET
    })
  }

  /* Poista tämä kommenteista, jos päätetäänkin myöhemmin, että lähetetäänkin taustalla
     aina sekä liitto- että kassavaltuutus myös silloin kun valitsee
     "Liityn vain Palvelualojen ammattiliiton jäseneksi"

  // Valutuutan liiton irtisanomaan jäsenyyteni edellisestä liitosta
  if ($edLiittoValtuutusCbox.length > 0) {
    $edLiittoValtuutusCbox.on('change', () => {
      const edLiittoValtuutusChecked = $edLiittoValtuutusCbox.is(':checked')

    // JLP-442 Säilytetään valtuutuskenttien nimet "ed_liitto_valtuutus" ja "ed_kassa_valtuutus_uusi" jottei tarvita
    // kantamuutoksia (mutta valitaan aina kummatkin kumman tahansa vailinnassa)
      if (edLiittoValtuutusChecked) {
        $edKassaValtuutusUusiCbox.prop('checked', true)
      } else {
        $edKassaValtuutusUusiCbox.prop('checked', false)
      }
    })
  }
  */

  const naytaKassa = () => {
    $edKassaSection.removeClass('hidden')
  }

  const resetoiKassa = () => {
    // Edellisen työttömyyskassan jäsenyys -> En siirry toisesta työttömyyskassasta
    $siirtyyKassastaRadios.filter('[value=E]').prop('checked', true)
    $siirtyyKassastaRadios.trigger('change')

    // Edellinen työttömyyskassa
    // triggeröityy $siirtyyKassastaRadios.on('change') -kuuntelijassa
    // (ei tarvita tässä)
  }

  const piilotaKassa = () => {
    $edKassaSection.addClass('hidden')
  }

  const naytaLiitto = () => {
    $edLiittoSection.removeClass('hidden')
  }

  const resetoiLiitto = () => {
    const checked = $siirtyyLiitostaCheckbox.is(':checked')

    if (checked) {
      //  Siirryn toisesta liitosta
      $siirtyyLiitostaCheckbox.prop('checked', false)
      $siirtyyLiitostaCheckbox.trigger('change') // Activate data-show-if bindings
    }
  }

  const piilotaLiitto = () => {
    $edLiittoSection.addClass('hidden')
  }

  const checkSiirtyyToisestaLiitosta = () => {
    $siirtyyLiitostaCheckbox.prop('checked', true)
    $siirtyyLiitostaCheckbox.trigger('change')
  }

  const checkSiirtyySuomalainenTK = () => {
    $siirtyyKassastaRadios.filter('[value=1]').prop('checked', true)
    $siirtyyKassastaRadios.trigger('change')
  }

  /*
   * PDF-generoinnin fiksit:
   */

  if (!isEmpty(window.queryparameters)) {

    // Liityn Palvelualojen ammattiliiton ja Palvelualojen työttömyyskassan jäseneksi /
    // Liityn vain Palvelualojen ammattiliiton jäseneksi
    $liittyyKassaLiittoRadio.trigger('change')

    const hasLiittoKassaValtuutus = (get(window.queryparameters, 'ed_kassa_valtuutus_uusi') === 'checked')
    if (hasLiittoKassaValtuutus) {
      // Valtuutan PAMin irtisanomaan jäsenyyteni edellisessä liitossa / työttömyyskassassa
      $edKassaValtuutusUusiCbox.prop('checked', true).trigger('change')
    }

    const _siirtyy_kassasta_uusi = get(window.queryparameters, 'siirtyy_kassasta_uusi')
    if (_siirtyy_kassasta_uusi !== null) {
      // Edellisen työttömyyskassan jäsenyys (suomalainen/ulkomainen/ei siirry)
      $siirtyyKassastaRadios.filter('[value=' + _siirtyy_kassasta_uusi.toString() + ']').prop('checked', true).trigger('change')
    }
    
    // Edellinen työttömyyskassa -select
    const _ed_kassa_uusi = get(window.queryparameters, 'ed_kassa_uusi')
    $edKassaSelect.val(_ed_kassa_uusi).trigger('change')

    // Edellinen työttömyyskassa "Muu"
    if (_ed_kassa_uusi === "0") {
      // Edellisen työttömyyskassan nimi (Muu)
      $('[name=ed_kassa_muu_uusi]').val(get(window.queryparameters, 'ed_kassa_muu_uusi'))
    }

    if (get(window.queryparameters, 'siirtyy_liitosta') === 'checked') {
      // Siirryn toisesta liitosta
      $siirtyyLiitostaCheckbox.prop('checked', true).trigger('change')
      
      // Edellinen liitto -select
      const _ed_liitto = get(window.queryparameters, 'ed_liitto')
      $edLiittoSelect.val(_ed_liitto).trigger('change')

      if (_ed_liitto === "0") {
        // Edellisen liiton nimi (Muu)
        $('[name=ed_liitto_muu]').val(get(window.queryparameters, 'ed_liitto_muu'))
      }

      const hasLiittoValtuutus = (get(window.queryparameters, 'ed_liitto_valtuutus') === 'checked')
      if (hasLiittoValtuutus) {
        // Valutuutan liiton irtisanomaan jäsenyyteni edellisestä liitosta
        $edLiittoValtuutusCbox.prop('checked', true).trigger('change')
      }
    }

    // Jäsenmaksun perintä (työnantaja/itsemaksava)
    const tyosuhteet = get(window.queryparameters, 'tyosuhde') || []
    const len = tyosuhteet.length || 0
    let tyosuhde, perinta, $tyosuhdePerintaRadios, i

    for (i = 0; i < len; i++) {
      tyosuhde = tyosuhteet[i]
      perinta = tyosuhde['perinta']
      $tyosuhdePerintaRadios = $("input:radio[name='tyosuhde[" + i.toString() + "][perinta]']")
      $tyosuhdePerintaRadios.filter('[value=' + perinta.toString() + ']').prop('checked', true)
    }
  }
})
